import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("页面不存在 | 韩国伦理在线观看");

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-8">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-600">
          <i className="ri-emotion-sad-line" />
        </span>
        <p className="mt-5 font-heading text-4xl font-black text-foreground-950">404</p>
        <h1 className="mt-2 font-heading text-lg font-bold text-foreground-900">
          抱歉，你访问的页面不存在
        </h1>
        <p className="mt-2 max-w-md text-sm text-foreground-500">
          页面可能已被移除或链接有误，返回首页继续浏览精彩的韩国伦理影视作品吧。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300"
          >
            搜索影视
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}